import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { boot } from './lib/tma';
import './index.css';

const launch = boot();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <App launch={launch} />
  </StrictMode>,
);
